module.exports = __webpack_public_path__ + "static/img/title-bottom.1b40c06f.png";